@if (isMobile) {
  <footer class="footerSite__cont footerSite__cont--mobile">
    <div class="footerSite__grid-item">
      <div class="footerSite__grid-item-href">
        <ng-container *ngTemplateOutlet="renderTravelLegals"></ng-container>
      </div>
      @if (isPE || btnRepentance) {
        <div class="footerSite__grid-item-href">
          <ng-container *ngTemplateOutlet="renderComplaintsBookAndPurchase"></ng-container>
        </div>
      }
    </div>
    <ng-container *ngTemplateOutlet="operatedTemplate;"></ng-container>
  </footer>
} @else {
  <footer class="footerSite__cont footerSite__cont--desktop">
    <div class="footerSite__grid">
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.CATEGORIES_TITLE' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-href">
          <ng-container *ngFor="let category of categories; trackBy: trackById">
            <div class="footerSite__link">
              <a target="_blank" [href]="category.link">
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [color]="fontColor.Primary"
                  [fontFamily]="fontFamily.Regular"
                  [text]="category.title | transloco">
                </app-ds-typography>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.INFORMATION_LINKS' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-href">
          <ng-container *ngFor="let link of footerLinks; trackBy: trackById">
            <div class="footerSite__link">
              <a rel="nofollow" [href]="link.url" target="_blank">
                <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.DOWNLOAD_APP' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-stores">
          <a
            class="footerSite__grid-item-stores footerSite__grid-item-stores--google"
            target="_blank"
            rel="nofollow"
            [href]="android.link">
            <app-ds-icon
              [size]="22"
              [icon]="icons.PlayStore">
            </app-ds-icon>
            <div class="footerSite__grid-item-stores--google-titles">
              <app-ds-typography
                [size]="fontSize.Minor"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.Regular"
                [text]="android.get_it">
              </app-ds-typography>
              <app-ds-typography
                [size]="fontSize.XS"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.SemiBold"
                [text]="android.name">
              </app-ds-typography>
            </div>
          </a>
          <a
            class="footerSite__grid-item-stores footerSite__grid-item-stores--apple"
            target="_blank"
            rel="nofollow"
            [href]="ios.link">
            <app-ds-icon
              [size]="22"
              [color]="iconFillColor.Light"
              [icon]="icons.Apple">
            </app-ds-icon>
            <div class="footerSite__grid-item-stores--apple-titles">
              <app-ds-typography
                [size]="fontSize.Minor"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.Regular"
                [text]="ios.get_it">
              </app-ds-typography>
              <app-ds-typography
                [size]="fontSize.XS"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.SemiBold"
                [text]="ios.name">
              </app-ds-typography>
            </div>
          </a>
        </div>
        <div class="footerSite__grid-item-stores">
          <a
            class="footerSite__grid-item-stores footerSite__grid-item-stores--huawei"
            target="_blank"
            rel="nofollow"
            [href]="huawei.link">
            <div class="footerSite__grid-item-stores-icon">
              <app-ds-icon
                [size]="22"
                [color]="iconFillColor.Error"
                [icon]="icons.AppGallery">
              </app-ds-icon>
            </div>
            <div class="footerSite__grid-item-stores--huawei-titles">
              <app-ds-typography
                [size]="fontSize.Minor"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.Regular"
                [text]="huawei.get_it">
              </app-ds-typography>
              <app-ds-typography
                [size]="fontSize.XS"
                [color]="fontColor.Invert"
                [fontFamily]="fontFamily.SemiBold"
                [text]="huawei.name">
              </app-ds-typography>
            </div>
          </a>
        </div>
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.FOLLOW_LINKS' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-social">
          <a
            class="footerSite__grid-item-social--facebook"
            [href]="facebookUrl"
            aria-label="footerSite--social--facebook"
            target="_blank"
            rel="nofollow">
            <app-ds-icon
              [size]="18"
              [color]="iconFillColor.Light"
              [icon]="icons.Facebook">
            </app-ds-icon>
          </a>
          <a
            class="footerSite__grid-item-social--x"
            aria-label="footerSite--social--x"
            [href]="twitterUrl"
            target="_blank"
            rel="nofollow">
            <app-ds-icon
              [size]="18"
              [color]="iconFillColor.Light"
              [icon]="icons.X">
            </app-ds-icon>
          </a>
          <a
            class="footerSite__grid-item-social--instagram"
            aria-label="footerSite--social--instagram"
            [href]="instagramUrl"
            target="_blank"
            rel="nofollow">
            <app-ds-icon
              [size]="18"
              [color]="iconFillColor.Light"
              [icon]="icons.Instagram">
            </app-ds-icon>
          </a>
        </div>
      </div>
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.RAPPI_LEGAL_TERMS' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-href">
          <ng-container *ngFor="let link of rappiLegalLinks; trackBy: trackById">
            @if (link.available) {
              <div class="footerSite__link">
                <a rel="nofollow" [href]="link.url" target="_blank">
                  <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
                </a>
              </div>
            }
          </ng-container>
        </div>
      </div>
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.TRAVEL_LEGAL_TERMS' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-href">
          <ng-container *ngTemplateOutlet="renderTravelLegals"></ng-container>
        </div>
      </div>
      <div class="footerSite__grid-item">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [tag]="'p'"
          [text]="'FOOTER_MODULE.TITLES.ABOUT' | transloco">
        </app-ds-typography>
        <div class="footerSite__grid-item-href">
          <ng-container *ngTemplateOutlet="operatedTemplate;"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="renderComplaintsBookAndPurchase"></ng-container>
      </div>
    </div>
    <div class="footerSite__divider">
      <app-ds-divider></app-ds-divider>
    </div>
    <div class="footerSite__all-rights-reserved">
      <app-ds-typography
        [size]="fontSize.XXS"
        [color]="fontColor.Secondary"
        [text]="'FOOTER_MODULE.CREATIVE_COMMONS' | transloco: { year: year }">
      </app-ds-typography>
    </div>
  </footer>
}

<ng-template #operatedTemplate>
  <div #openOperatorCert>
    <app-ds-typography
      class="footerSite__operated"
      [size]="fontSize.XXXS"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.Regular"
      [tag]="'p'"
      [text]="operatedBy$ | async">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #linkTemplate let-text="text" let-external="external">
  <app-ds-typography
    [size]="fontSize.XXXS"
    [color]="fontColor.Primary"
    [fontFamily]="isMobile ? fontFamily.SemiBold : fontFamily.Regular"
    [text]="text">
  </app-ds-typography>
</ng-template>

<ng-template #renderTravelLegals>
  <ng-container *ngFor="let link of travelLegalLinks; trackBy: trackById">
    @if (link.available) {
      <div class="footerSite__link" [class.partner]="link.partner" [class.divider]="link.divider">
        @if (!!link.state) {
          <a [routerLink]="[link.url]" [state]="link.state" skipLocationChange>
            <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
          </a>
        } @else {
          @if (isMobile && link.external) {
            <div class="footerSite__link--external" (click)="goToLink(link.url)">
              <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
            </div>
          } @else if (isMobile) {
            <a [routerLink]="[link.url]" skipLocationChange>
              <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
            </a>
          } @else {
            <a rel="nofollow" [href]="link.url" target="_blank">
              <ng-container *ngTemplateOutlet="linkTemplate; context: { text: link.name | transloco }"></ng-container>
            </a>
          }
        }
      </div>
    }
  </ng-container>
</ng-template>

<ng-template #renderComplaintsBookAndPurchase>
  @if (isPE) {
    <div class="footerSite__grid-item-href image">
      <div class="footerSite__image" (click)="goToLink(urlComplaintsBook)">
        <app-ds-image
          [size]="imageSize.None"
          [src]="COMPLAINTS_BOOK | ImageCdn"
          [width]="'165px'"
          [height]="'94px'">
        </app-ds-image>
      </div>
    </div>
    <div class="footerSite__grid-item-href image">
      <div class="footerSite__image" (click)="goToLink(urlFooterDocPDF)">
        <app-ds-image
          [size]="imageSize.None"
          [src]="MINCETUR | baseImage : MINCETUR_PATH"
          [width]="'165px'"
          [height]="'94px'">
        </app-ds-image>
      </div>
    </div>
  }
  @if (btnRepentance) {
    <div class="footerSite__grid-item-href">
      <app-ds-button
        [labels]="{ ButtonLabel: 'HOME_MODULE.CANCEL_PURCHASE' | transloco }"
        (clickEvent)="goToLink(repentanceUrl)">
      </app-ds-button>
    </div>
  }
</ng-template>

@if (showOperatiorCert) {
  <app-modal [classType]="'home-mobile-image-operated-by'" [width]="860" (toggleModal)="toggleOperatiorCert()">
    <ng-container content>
      <div class="footerSite__cert">
        <app-ds-image
          [size]="imageSize.None"
          [src]="footerOperatedByImages | baseImage: 'web/travel/footer/operator-legal'"
          [width]="isMobile ? '100%' : '800px'"
          [height]="isMobile ? 'auto' : '595px'">
        </app-ds-image>
      </div>
    </ng-container>
  </app-modal>
}
